import { createModule } from 'terrific-singleton';
import { TerrificSpec } from 'terrific-singleton/terrific-module';
import * as $ from 'jquery';

@createModule('StageKeyvisual')
/**
 * stage-keyvisual module implementation.
 *
 */
export class StageKeyvisual extends TerrificSpec {
	$ctx: JQuery;
	$inputElement: JQuery;

	/**
	 * start method, called on terrific bootstap
	 *
	 * @param {Object} resolve  function to call at the end of component start
	 * @returns {void}
	 */
	start(resolve: Function) {
		this.$ctx = $(this._ctx);
		this.$inputElement = this.$ctx.find('.js-m-stage-keyvisual__search-input');
		this.$inputElement.on('keyup', this._handleInputChange.bind(this));

		resolve();
	}
	/**
	 * stop method, called on terrific stop
	 *
	 * @returns {void}
	 */
	stop() {}

	_handleInputChange(event: any) {
		let inputString = this.$inputElement.val() as string;
		let $searchLink = $(this.$ctx).find('.js-m-stage-keyvisual__search-btn');
		let newLinkUrl = $searchLink.data('baseurl') + inputString;
		
		if (event.keyCode == 13) {
			window.location.href = newLinkUrl;
		}

		$searchLink.attr('href', newLinkUrl);
	}

}
